import { Link } from 'react-router-dom';
import { Instagram, Mail, MapPin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-[#2B2B2B] text-[#F6F1E9]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="text-2xl font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>
                Perkly
              </span>
              <span className="w-2 h-2 rounded-full bg-[#C8A97E]" />
            </div>
            <p className="text-sm text-[#F6F1E9]/60 leading-relaxed mb-5">
              Discover the best local deals, events & experiences near you.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://www.instagram.com/perklydeals2026"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram"
                className="w-9 h-9 rounded-full border border-[#F6F1E9]/20 flex items-center justify-center hover:border-[#C8A97E] hover:text-[#C8A97E] transition-colors"
                title="@perklydeals2026"
              >
                <Instagram size={16} />
              </a>
              <a
                href="mailto:support@useperkly.com"
                data-testid="footer-email"
                className="w-9 h-9 rounded-full border border-[#F6F1E9]/20 flex items-center justify-center hover:border-[#C8A97E] hover:text-[#C8A97E] transition-colors"
              >
                <Mail size={16} />
              </a>
            </div>
          </div>

          {/* Explore */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest text-[#C8A97E] mb-4">Explore</h4>
            <ul className="space-y-2.5">
              {['Food & Drink', 'Nightlife', 'Fitness & Wellness', 'Activities', 'Free Deals', 'Convenience Stores', 'Liquor Stores'].map((cat) => (
                <li key={cat}>
                  <Link
                    to={`/explore?category=${encodeURIComponent(cat)}`}
                    className="text-sm text-[#F6F1E9]/60 hover:text-[#C8A97E] transition-colors"
                  >
                    {cat}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest text-[#C8A97E] mb-4">Company</h4>
            <ul className="space-y-2.5">
              <li><Link to="/business/register" className="text-sm text-[#F6F1E9]/60 hover:text-[#C8A97E] transition-colors">For Businesses</Link></li>
              <li><Link to="/about" className="text-sm text-[#F6F1E9]/60 hover:text-[#C8A97E] transition-colors">About Perkly</Link></li>
              <li><a href="mailto:support@useperkly.com" className="text-sm text-[#F6F1E9]/60 hover:text-[#C8A97E] transition-colors">Contact Us</a></li>
              <li><a href="mailto:partners@useperkly.com" className="text-sm text-[#F6F1E9]/60 hover:text-[#C8A97E] transition-colors">Business Enquiry</a></li>
              <li><a href="https://www.instagram.com/perklydeals2026" target="_blank" rel="noreferrer" className="text-sm text-[#F6F1E9]/60 hover:text-[#C8A97E] transition-colors">Instagram @perklydeals2026</a></li>
              <li><a href="#" className="text-sm text-[#F6F1E9]/60 hover:text-[#C8A97E] transition-colors">Privacy Policy</a></li>
              <li><a href="#" className="text-sm text-[#F6F1E9]/60 hover:text-[#C8A97E] transition-colors">Terms of Service</a></li>
            </ul>
          </div>

          {/* Location */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest text-[#C8A97E] mb-4">Cities</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-[#F6F1E9]/60">
                <MapPin size={13} className="text-[#C8A97E] flex-shrink-0" />
                Athens, GA <span className="text-xs bg-[#C8A97E]/20 text-[#C8A97E] px-1.5 py-0.5 rounded-full ml-1">Live</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-[#F6F1E9]/40">
                <MapPin size={13} className="flex-shrink-0" />
                Atlanta, GA <span className="text-xs ml-1">Coming Soon</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-[#F6F1E9]/40">
                <MapPin size={13} className="flex-shrink-0" />
                Savannah, GA <span className="text-xs ml-1">Coming Soon</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-[#F6F1E9]/40">
                <MapPin size={13} className="flex-shrink-0" />
                Nashville, TN <span className="text-xs ml-1">Coming Soon</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-[#F6F1E9]/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-[#F6F1E9]/40">
            © 2025 Perkly. All rights reserved.
          </p>
          <p className="text-xs text-[#F6F1E9]/40">
            Built for local communities ❤️
          </p>
        </div>
      </div>
    </footer>
  );
}
